/**
 * BOOT §1 — the one list of routes that must render NO app chrome
 * (BottomTab, coach FAB) even when a user is signed in.
 *
 * Extracted so BottomTab and CoachFab can't drift apart again: `'/'` (the
 * native boot splash) was missing from both, so a fast session restore
 * painted the tab bar + FAB OVER the launch celebration. Both components
 * import this; the next chrome-free surface is a one-line change here.
 *
 * Matching grammar (both call sites): `pathname === p || pathname.startsWith(p + '/')`.
 * `'/'` matches only the exact root (via `'//'` it starts nothing else).
 */
export const BOOT_CHROME_FREE: ReadonlyArray<string> = [
  '/', // native boot splash — the launch celebration owns the full screen
  '/landing',
  '/onboarding',
  '/run',
  '/welcome',
];
